import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { ServiceCatalogEffects } from './effects';
import { reducer } from './reducer';
import { ServiceCatalogFacade } from './facade';
import { stateName } from './selectors';

@NgModule({
  imports: [CommonModule, StoreModule.forFeature(stateName, reducer), EffectsModule.forFeature([ServiceCatalogEffects])],
  exports: [],
  providers: [ServiceCatalogFacade],
  declarations: [],
})
export class ServiceCatalogStateModule {}
